export default __webpack_public_path__ + "static/voting-funds-772a2eee84aa5cccefb44f1c5efebe8a.svg";